/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
import * as i0 from "./home.style.css.shim.ngstyle";
import * as i1 from "@angular/core";
import * as i2 from "./home.service";
import * as i3 from "../common/services/httpInterceptor.service";
import * as i4 from "../common/services/cookieHandler.service";
import * as i5 from "@angular/http";
import * as i6 from "./home.component";
import * as i7 from "../common/services/routeContextProvider.service";
import * as i8 from "../common/services/sharedService";
import * as i9 from "@angular/router";
import * as i10 from "../common/services/routeHandler.service";
import * as i11 from "../common/services/formatter";
import * as i12 from "../common/services/formValidator.service";
import * as i13 from "../common/services/emitter.service";
var styles_HomeComponent = [i0.styles];
var RenderType_HomeComponent = /*@__PURE__*/ i1.ɵcrt({ encapsulation: 0, styles: styles_HomeComponent, data: {} });
export { RenderType_HomeComponent as RenderType_HomeComponent };
export function View_HomeComponent_0(_l) { return i1.ɵvid(0, [], null, null); }
export function View_HomeComponent_Host_0(_l) { return i1.ɵvid(0, [(_l()(), i1.ɵeld(0, 0, null, null, 3, "app-home", [], null, null, null, View_HomeComponent_0, RenderType_HomeComponent)), i1.ɵprd(512, null, i2.HomeService, i2.HomeService, [i3.HttpInterceptor, i4.CookieHandlerService]), i1.ɵprd(512, null, i5.HttpModule, i5.HttpModule, []), i1.ɵdid(3, 114688, null, 0, i6.HomeComponent, [i2.HomeService, i7.RouteContextProvider, i4.CookieHandlerService, i8.SharedService, i5.HttpModule, i9.ActivatedRoute, i9.Router, i10.RouteHandlerService, i11.Formatter, i12.FormValidator, i13.EmitterService], null, null)], function (_ck, _v) { _ck(_v, 3, 0); }, null); }
var HomeComponentNgFactory = /*@__PURE__*/ i1.ɵccf("app-home", i6.HomeComponent, View_HomeComponent_Host_0, {}, {}, []);
export { HomeComponentNgFactory as HomeComponentNgFactory };

